import { defineStore } from "pinia";
import profile from '@/network/profile';

export const useUserProfileStore = defineStore('user', {
  state: () => {
    return {
      User: {
      }
    }
  },
  getters: {
    isSalesAdmin (state) {
      return state.User.userRole === "BBSalesAdmin"
    }
  },
  actions: {
    async getUser () {
      const res = await profile.bIsSalesAdmin().then((res) => res.data);
      if (res) {
        this.User.useRole = "BBSalesAdmin"
      }
    }
  }
})
